import { render, staticRenderFns } from "./DeliveryIndex.vue?vue&type=template&id=23c20fbf"
import script from "./DeliveryIndex.vue?vue&type=script&lang=js"
export * from "./DeliveryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports